import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Imoveis from './pages/Imoveis';
import ImovelDetalhes from './pages/ImovelDetalhes';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { initGA, logPageView } from './utils/analytics';
import './App.css';

// Componente para rastrear mudanças de rota
function PageTracker() {
  const location = useLocation();

  useEffect(() => {
    logPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <PageTracker />
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/imoveis" element={<Imoveis />} />
            <Route path="/imovel/:id" element={<ImovelDetalhes />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin/login" element={<Login />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

